// extracted by mini-css-extract-plugin
export var Section = "CompanyNumbers-module--Section--1MJJe";
export var Inner = "CompanyNumbers-module--Inner--cjHlb";
export var Row = "CompanyNumbers-module--Row--JQy0-";
export var Total = "CompanyNumbers-module--Total---VVY2";
export var SectionTitle = "CompanyNumbers-module--SectionTitle--CUFzw";
export var TotalNum = "CompanyNumbers-module--TotalNum--W-Qxs";
export var TotalText = "CompanyNumbers-module--TotalText--HChoG";
export var Details = "CompanyNumbers-module--Details--N5fzd";
export var DetailsItem = "CompanyNumbers-module--DetailsItem--yq-vj";
export var DetailsItemNum = "CompanyNumbers-module--DetailsItemNum--R91r8";
export var DetailsItemText = "CompanyNumbers-module--DetailsItemText--+RcJe";
export var arrowLeft = "CompanyNumbers-module--arrowLeft--M4+6r";
export var arrowRight = "CompanyNumbers-module--arrowRight--osxy3";